var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 77.5,
    viewBox: "0 0 95 77.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 95,
    height: 77.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 95,
    height: 77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 37.549,
    height: 37.549,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-15.034 -136.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_3_4",
    "data-name": "Component 3 \\u2013 4",
    transform: "translate(15.034 136.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 95,
    height: 77,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 75.311,
    height: 57.025,
    rx: 8,
    transform: "translate(9.501 7.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 75.311,
    height: 57.025,
    rx: 8,
    transform: "translate(9.501 7.5)",
    fill: "none",
    stroke: "#838383",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M46.05,63.12s6.17,15.352,9.274,13.765S62.366,63.12,62.366,63.12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M46.05,63.12s6.17,15.352,9.274,13.765S62.366,63.12,62.366,63.12",
    fill: "none",
    stroke: "#838383",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Component_6_1",
    "data-name": "Component 6 \\u2013 1",
    transform: "translate(43.76 154.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M37.549,18.774A18.774,18.774,0,1,1,18.774,0,18.729,18.729,0,0,1,37.549,18.774",
    transform: "translate(0 0)",
    fill: "#dd6b9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M43,18.774A18.773,18.773,0,0,1,24.222,37.549V0A18.775,18.775,0,0,1,43,18.774",
    transform: "translate(-5.448 0)",
    fill: "#d51a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M33.2,38.351v.074a18.773,18.773,0,0,1-25.3,0v-.074a12.651,12.651,0,0,1,25.3,0",
    transform: "translate(-1.777 -5.78)",
    fill: "#7985eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M36.873,38.351v.074a18.707,18.707,0,0,1-12.651,4.9V25.7A12.651,12.651,0,0,1,36.873,38.351",
    transform: "translate(-5.448 -5.78)",
    fill: "#4b5be6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M29.73,16.191A7.759,7.759,0,1,1,21.97,8.432a7.768,7.768,0,0,1,7.759,7.759",
    transform: "translate(-3.196 -1.896)",
    fill: "#ffdba9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M31.981,16.191a7.768,7.768,0,0,1-7.759,7.76V8.432a7.768,7.768,0,0,1,7.759,7.759",
    transform: "translate(-5.448 -1.896)",
    fill: "#ffc473"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.7851de1f12bd8157a4e09a2eea5b4869.svg";
export { ForwardRef as ReactComponent };